import Vue from 'vue'
import Vuex from 'vuex'
// import user from './module/user'
// import Test from './module/test'

Vue.use(Vuex)

export default new Vuex.Store({
  // modules: {
  //   user,
  //   Test
  // }
})
